import LogInNavBar from "./LogInNavBar"
import LogIn from "./LogIn"
import Home from "./Home"
import { Route, Routes, useLocation } from "react-router-dom"
import {AnimatePresence } from "framer-motion";
import { useState } from "react"
import OurServices from "./OurServices"
import ContactUs from "./ContactUs"
import PlansPage from "./Plans";
import Register from "./Register";
import Footer from "./Footer";

export default function HomeLogIn(){

    const [active,setActive] = useState("");
    const [pagesOut, setPagesOut] = useState({
        logInOut: false,
        homeOut: false,
        servicesOut: false,
        constactOut:false,
        plansOut:false
    })
    const location = useLocation();

    return(
        <div style={{minHeight:"100vh",
            //linear-gradient(195deg, #9d00ff, #ffffff)
        width:"100%", background:"white"}}>
            <LogInNavBar active={active} setActive={setActive} pagesOut={pagesOut} setPagesOut={setPagesOut}/>     
            <AnimatePresence mode="wait"> 
                <Routes location={location} key={location.pathname}>
                    <Route path="/logIn" element={<LogIn setActive={setActive} pagesOut={pagesOut} setPagesOut={setPagesOut}/>}/>
                    <Route path="/" element={<Home setActive={setActive} pagesOut={pagesOut} setPagesOut={setPagesOut}/>}/>
                    <Route path="/services" element={<OurServices setActive={setActive} pagesOut={pagesOut} setPagesOut={setPagesOut}/>}/>
                    <Route path="/contact-us" element={<ContactUs setActive={setActive} pagesOut={pagesOut} setPagesOut={setPagesOut}/>}/>
                    <Route path="/plans" element={<PlansPage setActive={setActive} pagesOut={pagesOut}/>} />
                    <Route path="/register" element={<Register setActive={setActive}/>} />
                </Routes>
                <Footer/>
                </AnimatePresence>

        </div>
    )
}